import { render } from "./FishingAction.vue?vue&type=template&id=29aef6dd&scoped=true"
import script from "./FishingAction.vue?vue&type=script&lang=js"
export * from "./FishingAction.vue?vue&type=script&lang=js"

import "./FishingAction.vue?vue&type=style&index=0&id=29aef6dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29aef6dd"]])

export default __exports__